import type { FunctionComponent } from "react";

import { useTrackImpressionEventByIntersection } from "shared/hooks";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type {
  MyNewsArticleTriggerPoint,
  MyNewsScrollCompleteImpressionEvent,
} from "scmp-app/components/tracking/google-analytics-4/types";

type Props =
  | {
      complete_type: "daily5";
    }
  | {
      complete_type: "topic";
      index: number;
      name: string;
    };

const MY_NEWS_ARTICLE_TRIGGER_POINT_BY_INDEX: Partial<Record<number, MyNewsArticleTriggerPoint>> = {
  2: "3rd_articles",
  7: "8th_articles",
  12: "13_articles",
  17: "18_articles",
  22: "23_articles",
  27: "28_articles",
  32: "33_articles",
  37: "38_articles",
  42: "43_articles",
  44: "45_articles",
};

export const MynewsCompleteTypeImp: FunctionComponent<Props> = props => {
  const getTriggerPointName = (index: number): MyNewsArticleTriggerPoint | undefined =>
    MY_NEWS_ARTICLE_TRIGGER_POINT_BY_INDEX[index];

  const myNewsScrollCompleteGA4ImpressionEvent: () => MyNewsScrollCompleteImpressionEvent = () => {
    if (props.complete_type === "topic") {
      return {
        action: "imp",
        category: "mynews",
        customized_parameters: {
          complete_type: "topic",
          follow_name: props.name,
          trigger_point: getTriggerPointName(props.index),
          view: "feed",
        },
        subcategory: "scroll_completion",
      } as const;
    }

    return {
      action: "imp",
      category: "mynews",
      customized_parameters: {
        complete_type: "daily5",
      },
      subcategory: "scroll_completion",
    } as const;
  };

  const {
    captureTrackImpressionEventTargetElement:
      feedViewArticleCaptureTrackImpressionEventTargetElement,
  } = useTrackImpressionEventByIntersection<MyNewsScrollCompleteImpressionEvent>({
    ga4TrackingHandler: sendGA4Tracking,
    getGa4Event: myNewsScrollCompleteGA4ImpressionEvent,
    options: {
      intersectionThreshold: [0.1],
      isSendGA4Tracking: true,
      shouldSendOnce: true,
      shouldThrottle: true,
    },
  });

  return <div ref={feedViewArticleCaptureTrackImpressionEventTargetElement} />;
};

MynewsCompleteTypeImp.displayName = "MynewsCompleteTypeImp";
